import SPT1770 from './SPT1770'

export default SPT1770